import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DropdownDetail from '../DropdownDetail';
import {
  formatCurrency,
  formatDate,
  formatPercentage, 
  capitalize
} from '../../../../utils/FormatUtil';
import './detail.css';
import BannerLiquidate from '../BannerLiquidate';

class Detail extends Component {
  constructor() {
    super();
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidMount() {
    const { getTimeDeposit, id } = this.props;

    getTimeDeposit(id);
  }

  handleItemClick(id) {
    const { getTimeDeposit } = this.props;

    getTimeDeposit(id);
  }

  esLiquidable(timeDeposit,list){

    const depositFilter = list.filter(item => {
      return Number(item.id) === timeDeposit.numeroDeposito;  
    });

    if(depositFilter[0]!==undefined){
      return depositFilter[0].liquidable;
    }
    else{
      return false;
    }
    
  }

  render() {
    const { timeDeposit, list } = this.props;

    const liquidable = this.esLiquidable(timeDeposit,list);

    const filteredList = list.filter(item => {
      return Number(item.id) !== timeDeposit.numeroDeposito;
    });

    return (
      <Container className="dap_detalle">
        <Row>
          <Col md={8} sm={6} xs={12}>
            <b>Depósito a Plazo número</b>
            <br /> {timeDeposit.numeroDeposito}
          </Col>
          <Col md={4} sm={6} xs={12}>
            <DropdownDetail
              data={filteredList}
              onItemClick={this.handleItemClick}
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={3} sm={6} xs={6} className="dap_listado-espacio-abajo">
            <b>Monto invertido</b>
            <p>{formatCurrency(timeDeposit.capital || 0)}</p>
          </Col>
          <Col md={3} sm={6} xs={6} className="dap_verde">
            <b>Ganancia</b>
            <p>
              {formatCurrency(timeDeposit.ganancia || 0)}
            </p>
          </Col>
          <Col md={3} sm={6} xs={6}>
            <b>Monto al vencimiento</b>
            <p>{formatCurrency(timeDeposit.montoRescate || 0)}</p>
          </Col>
          <Col md={3} sm={6} xs={6}>
            <b>Estado</b>
            <p>{timeDeposit.estado}</p>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col md={3} sm={6} xs={6} className="dap_listado-espacio-abajo">
            <b>Plazo</b>
            <p>{timeDeposit.plazoPactado} días</p>
          </Col>
          <Col md={3} sm={6} xs={6}>
            <b>Tipo de depósito</b>
            <p>{capitalize((timeDeposit.tipoDeposito || '').toLowerCase())}</p>
          </Col>
          <Col md={3} sm={6} xs={6}>
            <b> Fecha de inicio</b>
            <p>{formatDate(timeDeposit.fechaIngreso || '')}</p>
          </Col>
          <Col md={3} sm={6} xs={6}>
            <b>Fecha de vencimiento</b>
            <p>{formatDate(timeDeposit.fechaVencimiento || '')}</p>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col md={6} sm={6} xs={12} className="dap_listado-espacio-abajo">
            <b>Tasa base:</b> <b className="dap_verde">{formatPercentage(timeDeposit.tasaBase)}</b>
            <p>Tasa definida en base a un período de 30 días.</p>
          </Col>
          <Col md={6} sm={6} xs={12}>
            <b>Tasa período:</b> <b className="dap_verde">{formatPercentage(timeDeposit.tasaPeriodo)}</b>
            <p>Tasa de interés total para todo el período estipulado en la captación. Resulta de la división de la Tasa Base por 30 y multiplicándola por el número de días de la Captación.</p>
          </Col>
        </Row>
        <hr />

        {liquidable ? (
          <Row>
            <Col md={12}>
              <BannerLiquidate id={timeDeposit.numeroDeposito} />
            </Col>
          </Row>
        ) : null}
      </Container>
    );
  }
}

export default Detail;
